var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgDashboard = function SvgDashboard(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Menu_1",
    "data-name": "Menu 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rectangle",
    fill: "none",
    d: "M0 0H24V24H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66128",
    "data-name": "Group 66128",
    transform: "translate(-6 -6)",
    fill: "currentColor",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28060",
    "data-name": "Path 28060",
    d: "M26.387,11.226h-.323V8.968A.968.968,0,0,0,25.1,8H10.9a.968.968,0,0,0-.968.968v2.258H9.613A1.615,1.615,0,0,0,8,12.839v9.677a1.615,1.615,0,0,0,1.613,1.613h6.129v1.29H15.1a1.29,1.29,0,0,0-1.29,1.29v.968a.323.323,0,0,0,.323.323h7.742a.323.323,0,0,0,.323-.323V26.71a1.29,1.29,0,0,0-1.29-1.29h-.645v-1.29h6.129A1.615,1.615,0,0,0,28,22.516V12.839A1.615,1.615,0,0,0,26.387,11.226ZM10.581,8.968a.323.323,0,0,1,.323-.323H25.1a.323.323,0,0,1,.323.323v9.677a.323.323,0,0,1-.323.323H10.9a.323.323,0,0,1-.323-.323Zm-.968,2.9h.323v6.774a.968.968,0,0,0,.968.968H25.1a.968.968,0,0,0,.968-.968V11.871h.323a.968.968,0,0,1,.968.968V20.9H8.645V12.839A.968.968,0,0,1,9.613,11.871ZM21.548,26.71v.645h-7.1V26.71a.645.645,0,0,1,.645-.645H20.9A.645.645,0,0,1,21.548,26.71Zm-1.935-1.29H16.387v-1.29h3.226Zm6.774-1.935H9.613a.968.968,0,0,1-.968-.968v-.968h18.71v.968A.968.968,0,0,1,26.387,23.484Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28062",
    "data-name": "Path 28062",
    d: "M219.226,79.419a.323.323,0,0,0,.323.323h4.516a.323.323,0,0,0,.323-.323v-1.29a.323.323,0,0,0-.323-.323h-.323V72.323a.323.323,0,0,0-.323-.323h-1.29a.323.323,0,0,0-.323.323v5.484h-.645V73.613a.323.323,0,0,0-.323-.323h-1.29a.323.323,0,0,0-.323.323v5.806Zm3.226-6.774h.645v5.161h-.645Zm-2.581,1.29h.645v3.871h-.645Zm3.871,4.516V79.1h-3.871v-.645Z",
    transform: "translate(-199.613 -61.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28063",
    "data-name": "Path 28063",
    d: "M90.581,45.161A2.581,2.581,0,1,0,88,42.581,2.581,2.581,0,0,0,90.581,45.161Zm0-.645a1.923,1.923,0,0,1-1.12-.36L90.714,42.9h1.774A1.937,1.937,0,0,1,90.581,44.516Zm1.906-2.258H90.9V40.674A1.938,1.938,0,0,1,92.487,42.258Zm-2.229-1.584v1.774L89,43.7a1.93,1.93,0,0,1,1.253-3.027Z",
    transform: "translate(-75.774 -29.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28065",
    "data-name": "Path 28065",
    d: "M88,216h6.774v.645H88Z",
    transform: "translate(-76.774 -198.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28066",
    "data-name": "Path 28066",
    d: "M88,184h6.774v.645H88Z",
    transform: "translate(-76.774 -167.613)"
  }))));
};

export default SvgDashboard;